var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHangdog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    width: 20,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#c88143",
      stroke: "#562800",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.7,15.6 c1.6,-1.8 3.2,-3.6 5,-4 L14.6,11.4 C16.5,11.5 17.5,8.4 17.7,7.1 16.1,6.7 14.6,6.4 13.2,5.3 13.7,1.3 8.4,1.3 6.3,2.6 4.8,3.4 3.3,4.4 2.1,5.9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m3.3,4.7 c1.3,8.5 4.4,1.7 3.4,-0"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#000000"
    },
    cx: 11,
    cy: 5,
    r: 1
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHangdog);
export default __webpack_public_path__ + "static/media/hangdog.b8c56d8d341e6e3a6a3315e983a2fafe.svg";
export { ForwardRef as ReactComponent };